export default {
  selectedClassId: 'all',

  managingClasses: {},

  isClassStudent: null,
};



// WEBPACK FOOTER //
// ./src/app/classes/store/state.js